// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import '../node_modules/jquery/dist/jquery.js'
import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import '../node_modules/bootstrap-vue/dist/bootstrap-vue.css'
import '../node_modules/bootstrap/dist/js/bootstrap.min.js'
// import '../node_modules/masonry-layout/dist/masonry.pkgd.min.js'
import '../node_modules/@fortawesome/fontawesome-free/js/fontawesome.min.js'
import '../node_modules/@fortawesome/fontawesome-free/css/fontawesome.min.css'

import './scripts/nm.css'
import './scripts/script.js'
// import '../node_modules/@chenfengyuan/vue-carousel/dist/vue-carousel.js'

import 'vue-select/dist/vue-select.css'
import vSelect from 'vue-select'
import VueCarousel from 'vue-carousel'
import VuePictureSwipe from 'vue-picture-swipe'
// import {VueMasonryPlugin} from 'vue-masonry';
// Vue.use(VueMasonryPlugin);
import { library } from '@fortawesome/fontawesome-svg-core'
import { faClock, faChevronLeft, faChevronRight, faSync, faEnvelope, faCompass, faMap, faMapMarkerAlt, faMapMarker, faRoute, faMapMarkedAlt, faLeaf, faTree, faMountain, faLandmark, faAngleRight, faPhone, faChevronCircleRight, faChevronCircleLeft, faHandsHelping, faHandPointUp, faPalette, faBinoculars, faMapSigns } from '@fortawesome/free-solid-svg-icons'
import { faGithub, faTwitter, faFacebook, faInstagram, faYoutube, faLinkedin, faTripadvisor } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

Vue.component('v-select', vSelect)
Vue.use(vSelect)
Vue.use(VueCarousel)
Vue.component('vue-picture-swipe', VuePictureSwipe)

library.add(faClock, faChevronLeft, faChevronRight, faSync, faEnvelope, faCompass, faMap, faMapMarkerAlt, faMapMarker, faRoute, faMapMarkedAlt, faLeaf, faTree, faMountain, faLandmark, faAngleRight, faPhone, faChevronCircleRight, faChevronCircleLeft, faHandsHelping, faHandPointUp, faPalette, faBinoculars, faMapSigns)
library.add(faGithub, faTwitter, faFacebook, faInstagram, faYoutube, faLinkedin, faTripadvisor)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.config.productionTip = false
// eslint-disable-next-line
var app = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js